import Vue from 'vue'
import { Mixin } from 'vue-mixin-decorator'
import Router from 'vue-router'

import { URL } from '@/util/url'

/**
 * Cross → MPA/SPA両方に対応の意。Cross Origin とか Cross Site のCrossのイメージ.
 * https://github.com/my-color/front/pull/1418#discussion_r285958755
 * もう少し良い命名あれば改名するかも
 */
@Mixin
export default class CrossPageTransition extends Vue {
  $router: Router

  goTo(nextPath: string, afterTransit: () => void = () => { /* nop */ }): void {
    if (URL.isSpa(nextPath)) {
      const spaTarget = URL.extractMaybeSpaPath(nextPath)
      this.$router.push(spaTarget === '' ? '/' : spaTarget, afterTransit)

      return
    }

    location.href = URL.createUrlForCurrentOrigin(nextPath)
    afterTransit()
  }
}
